var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6959 3.25663C6.60052 3.25663 7.33658 2.52618 7.33658 1.62847C7.33658 0.730754 6.60083 0 5.6959 0C4.79097 0 4.05521 0.730447 4.05521 1.62816C4.05521 2.52588 4.79128 3.25632 5.6959 3.25632V3.25663Z",
    fill: "#726FB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53681 10.6676L4.90701 10.492C7.65984 9.18644 9.90855 9.01795 11.5907 9.99116C12.6521 10.6053 13.4797 11.6936 13.9838 13.1391C14.2866 14.0071 14.3883 14.7529 14.418 15.0313L17.0221 17.1324C17.1767 13.009 16.1911 10.1017 14.0893 8.48607C13.3244 7.89834 12.4056 7.48063 11.3587 7.24523C10.5132 7.05526 9.58257 6.98221 8.5926 7.02886C6.89501 7.10866 5.597 7.51746 5.58432 7.52145L5.04309 7.69424L6.18832 4.95721H3.63374L1.17225 10.76L6.98872 15.8541L8.82146 14.2026L4.53712 10.6679L4.53681 10.6676Z",
    fill: "#726FB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4627 18.2854C11.7546 19.7849 10.0812 20.6123 8.48595 20.7459C6.79176 20.8873 5.59457 20.2158 4.8885 19.6275C3.5107 18.4793 3.02514 16.7895 2.92463 16.3804L0.0116053 13.8833C-0.0957119 16.6863 0.546026 18.8995 1.9229 20.4666C2.62124 21.2615 3.50575 21.8836 4.55233 22.3157C5.44829 22.6855 6.43733 22.9093 7.49164 22.9802C9.20098 23.0953 10.7421 22.6871 11.7339 22.3243C12.8148 21.929 13.4974 21.4996 13.5042 21.4956L13.6829 21.3824L13.8323 21.5319L15.2794 22.9799H18.8923L13.4621 18.2857L13.4627 18.2854Z",
    fill: "#726FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.2857ee04083cbfd44d7a22c92418d810.svg";
export { ForwardRef as ReactComponent };